import { request } from '../request';

/**
 * 发送通用手机号或邮箱验证码
 * POST /verification-challenges
 * 验证码用途由 purpose 指定，验证成功后可换取临时 verification_token。
 *
 * @param data 请求体参数 (purpose, target)
 */
export function fetchSendVerificationChallenge(
  data: Api.Verification.VerificationChallengeRequest
) {
  return request<Api.Verification.VerificationChallengeResponse>({
    url: '/verification-challenges',
    method: 'POST',
    data,
  });
}

/**
 * 校验验证码并获取临时 token
 * POST /verification-challenges/verify
 * token 绑定当前账号、purpose 和 target，只能用于对应业务提交。
 *
 * @param data 请求体参数 (code, purpose, target)
 */
export function fetchVerifyVerificationChallenge(
  data: Api.Verification.VerifyVerificationChallengeRequest
) {
  return request<Api.Verification.VerificationTokenResponse>({
    url: '/verification-challenges/verify',
    method: 'POST',
    data,
  });
}

/**
 * 作废临时验证码 token
 * DELETE /verification-tokens/{token}
 * 用户修改手机号或邮箱时调用，作废旧 token，防止旧验证结果复用。
 *
 * @param token 临时验证码 token
 */
export function fetchRevokeVerificationToken(token: string) {
  return request<Record<string, boolean>>({
    url: `/verification-tokens/${encodeURIComponent(token)}`,
    method: 'DELETE',
  });
}
